import getIn from 'immutable-less/transmute/getIn';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import PersonalizedTextView from 'automation-ui-action-features/personalized-text/PersonalizedTextView';
import * as PropertyValueTypes from 'automation-ui-flow-core/fields/PropertyValueTypes';
import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
const CreateObjectTitleLabel = ({
  flowObjectTypeId,
  propertyAssignment,
  omitQuotes,
  propertyDefinition,
  objectTypeIdForProperty
}) => {
  const isStaticPropertyType = getIn(['type'], propertyAssignment) === PropertyValueTypes.STATIC_VALUE;
  const staticPropertyValue = getIn(['value'], propertyAssignment);
  const dynamicPropertyName = getIn(['propertyName'], propertyAssignment);
  const noPropertyAssignment = !propertyAssignment || !staticPropertyValue && !dynamicPropertyName;
  if (noPropertyAssignment) {
    return /*#__PURE__*/_jsx(MissingLabel, {
      type: "name"
    });
  }
  const text = isStaticPropertyType ? getDisplayedValue(propertyDefinition || {}, staticPropertyValue, undefined, {}, objectTypeIdForProperty) : `{{ enrolled_object.${dynamicPropertyName} }}`;
  return /*#__PURE__*/_jsx(PersonalizedTextView, {
    propertyTypeId: flowObjectTypeId,
    text: omitQuotes ? String(text) : `"${text}"`
  });
};
export default CreateObjectTitleLabel;